export default __webpack_public_path__ + "static/font-7100cc7e107f8928cf0989c88e1d8745.woff";